export const email = "dondeptu@gmail.com";